import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";

export const SUPERSEDE_NOTICE =
  "These proposals were made without a job. Matching one re-runs the agent and replaces them.";

export const SupersedeNotice = () => (
  <Alert color="information" role="note" className="mt-2 w-full">
    <InfoIcon />
    <AlertDescription>{SUPERSEDE_NOTICE}</AlertDescription>
  </Alert>
);
